import baseConfig from './config';
import type { Config } from './config';

/**
 * Source de vérité:
 * - si une config runtime est fournie, elle prime
 * - sinon on retombe sur la config du projet (`Config/config.ts`)
 * - défaut: true (on ne casse pas les projets existants)
 */
export function isDevModeEnabled(runtimeConfig?: Config): boolean {
  const v = runtimeConfig?.devMode?.enabled;
  if (typeof v === 'boolean') return v;
  const base = (baseConfig as any)?.devMode?.enabled;
  return typeof base === 'boolean' ? base : true;
}

/**
 * Pour l’instant, on lie la persistance de config dans localStorage au dev mode.
 * (Ça laisse la porte ouverte à un réglage séparé plus tard.)
 */
export function isConfigLocalStorageEnabled(runtimeConfig?: Config): boolean {
  return isDevModeEnabled(runtimeConfig);
}



